(function () {
  'use strict';

  if (window.__emelloPdpPromoBound) return;
  window.__emelloPdpPromoBound = true;

  var KLAVIYO_SELECTOR = '[data-pdp-promo-action="klaviyo_popup"]';

  function reportToSentry(message, context) {
    if (!window.Sentry || typeof window.Sentry.captureMessage !== 'function') return;

    window.Sentry.captureMessage(message, {
      level: 'warning',
      extra: context || {}
    });
  }

  function pushDataLayer(eventName, trigger, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      product_id: trigger.dataset.productId || null,
      product_handle: trigger.dataset.productHandle || null,
      klaviyo_form_id: trigger.dataset.klaviyoFormId || null
    }, extra || {}));
  }

  function getTrigger(event) {
    if (!(event.target instanceof Element)) return null;
    return event.target.closest(KLAVIYO_SELECTOR);
  }

  document.addEventListener('click', function (event) {
    var trigger = getTrigger(event);
    if (!trigger) return;

    event.preventDefault();

    var formId = (trigger.dataset.klaviyoFormId || '').trim();

    if (!formId) {
      pushDataLayer('emello_pdp_promo_open_failed', trigger, {
        failure_reason: 'missing_klaviyo_form_id'
      });
      reportToSentry('PDP promo could not open because the Klaviyo form ID is missing.', {
        product_id: trigger.dataset.productId || null,
        product_handle: trigger.dataset.productHandle || null
      });
      return;
    }

    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);

      pushDataLayer('emello_pdp_promo_clicked', trigger, {
        promo_action: 'klaviyo_popup'
      });

      document.dispatchEvent(new CustomEvent('emello:pdp-promo-clicked', {
        detail: {
          action: 'klaviyo_popup',
          formId: formId,
          productId: trigger.dataset.productId || null,
          productHandle: trigger.dataset.productHandle || null
        }
      }));
    } catch (error) {
      pushDataLayer('emello_pdp_promo_open_failed', trigger, {
        failure_reason: 'klaviyo_trigger_error'
      });
      reportToSentry('PDP promo could not trigger the Klaviyo popup.', {
        product_id: trigger.dataset.productId || null,
        product_handle: trigger.dataset.productHandle || null,
        error_message: error && error.message ? error.message : String(error)
      });
    }
  });
})();